import React from "react";

const PurchaseTracker = (props) => {
  return <div>PurchaseTracker</div>;
};

export default React.memo(PurchaseTracker);
